const isSsr = () => typeof window === "undefined";

export default isSsr;
